import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { EvsAddressService } from '../../../../common/services/EvsAddress.service';
import { ProductRoadmapService } from './services/productRoadmap.service';
import { Subject } from 'rxjs/Subject';
import { environment } from '../../../../../environments/environment';
import { BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { UploadService } from '../../../../common/services/Upload.service';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BatchService } from '../batchstamp/batch.service';
import { HttpClient } from '@angular/common/http';
import { ExportService } from 'app/common/services/Export.service';
import * as moment from 'moment';
// @ts-ignore
import _ = require('lodash');
import { EvsStampService } from '../../../../common/services/EvsStamp.service';
import { IOption } from 'ng-select';
import { EvsErr } from '../../evs/evsErr';
import { TranslateService } from '@ngx-translate/core';

declare function baseTracking(appId);

declare function enterScreenView(screenName: any, contentType: any, referrer: any);

declare function visibleContent(regionName: any, contentName: any, index: any);

declare function clickTracking(regionName: any, contentName: any, target: any, payload: any);

declare function alertMsg(alertType: any, alertMessage: any);

declare function searchEvent(keywords: any, params: any, order: any, sort: any)

declare var $: any;

@Component({
  selector: 'app-productRoadmap',
  templateUrl: './productRoadmap.component.html',
  styleUrls: ['./productRoadmap.component.css'],
  providers: [ProductRoadmapService],
})
export class ProductRoadmapComponent implements OnInit {
  @ViewChild('select2Api') select2Api;
  @ViewChild('selectAgencyApi') selectAgencyApi;
  @ViewChild('returnStamp') returnStamp: ModalDirective;
  @ViewChild('returnStampList') returnStampList: ModalDirective;
  @ViewChild('cancelStamp') cancelStamp: ModalDirective;
  @ViewChild('editStamp') editStamp: ModalDirective;
  @ViewChild('returnStampBox') returnStampBox: ModalDirective;
  @ViewChild('validateDownloadExcelPopup') validateDownloadExcelPopup: ModalDirective;
  @ViewChild('boxStampDistribution') boxStampDistribution;
  page_title = 'LO_TRINH_SAN_PHAM';
  isDistribution: Boolean = false;
  isList: Boolean = true;
  isReadmore: Boolean = false;
  stasitic: any;
  reason = '';
  lotem: string;
  addContent = '';
  disabledLog = false;
  listBatches = [
    {
      label: 'Lo 1',
      value: 1,
    },
    {
      label: 'Lo 2',
      value: 2,
    },
  ];
  data = [];
  data_stamp = [];

  total_data: 0;
  total_stamp: 0;
  item_active: any;
  pageIndex = 1;
  page_size = 10;
  totalPage: number;
  item_detail: any;
  dataSelectFromAgency = '';
  dataSelectToAgency = '';
  unsubscribe$ = new Subject<void>();
  query;
  queryStamp = {};
  public fromArea: Array<any> = [];
  public toArea: Array<any> = [];
  formStamp = this.fb.group({
    code: null,
    type: null,
    lotId: null,
    productId: null,
    status: null,
  });
  pageIndexStamp = 1;
  pageSizeStamp = 10;
  supplier = [];
  historyId;
  type_stamp = [
    {
      label: 'TEM_THUNG',
      value: 0,
    },
    {
      label: 'TEM_SAN_PHAM',
      value: 1,
    },
  ];
  status_stamp = [
    {
      label: 'DA_XAC_NHAN',
      value: 1,
    },
    {
      label: 'CHUA_XAC_NHAN',
      value: 0,
    },
  ];
  loading_left = false;
  getCities = [];
  isCheckAll = false;
  listOfChecked = {};
  list_id = [];
  loading_stamp = false;
  disabledConfirm = false;
  disabledReturnBox = false;
  disabledTakeBack = false;
  singleReturnBox = {};
  singleTakeBack = {};

  returnStampBoxImages: any = [];
  boxTypeList: any = [];
  formCratingBatch: FormGroup = this.fb.group({
    name: [''],
    note: [''],
  });
  formWithdrawal: FormGroup = this.fb.group({
    stampCode: ['', [Validators.required]],
  });
  isDownImport: boolean = false;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    public addressService: EvsAddressService,
    public productRoadmapService: ProductRoadmapService,
    public router: Router,
    private upload: UploadService,
    private modalService: BsModalService,
    private batchService: BatchService,
    public httpClient: HttpClient,
    private exportService: ExportService,
    private stampService: EvsStampService,
    private translate: TranslateService,
  ) {
  }

  ngOnInit() {
    baseTracking(environment.appIdTracking);
    enterScreenView('qcheck_distribute_history', 'others', '');
    this.isDistribution = false;
    this.isWithdrawal = false;
    this.isList = true;

    // Khởi tạo Select2 lần đầu và cập nhật khi đổi ngôn ngữ
    this.initSelect2();
    this.translate.onLangChange.subscribe(() => {
      this.initSelect2();
    });

    // Các lời gọi khởi tạo dữ liệu chỉ cần một lần
    this.productRoadmapService.getSupplier(this.query).subscribe((res) => {
      const supplier = [];
      res.data.items.map((val) => {
        supplier.push({ label: val.name, value: val.id });
      });
      this.supplier = supplier;
    });
    // @ts-ignore
    this.loading_left = true;
    const agencyData = JSON.parse(localStorage.getItem('agencyId'));
    if (agencyData) {
      const newOption = new Option(agencyData.name, agencyData.id, false, false);
      $('#distributionAgent').append(newOption).trigger('change');
      $('#classify').val('0').trigger('change');
      localStorage.removeItem('agencyId');
    }
    this.getFromArea();
    this.getListBoxType();
  }

  private initSelect2() {
    this.translate.get([
      'KHU_VUC_XUAT',
      'KHU_VUC_NHAN',
      'TRANG_THAI_XAC_NHAN',
      'TINH_TRANG_CANH_BAO',
      'KIEU_PHAN_PHOI',
      'HINH_THUC_DONG_GOI',
      'TINH_TRANG_XAC_NHAN',
      'PHAN_LOAI',
      'LO_TEM',
      'SAN_PHAM',
      'TRANG_THAI',
      'DAI_LY_PHAN_PHOI',
      'CHON_NHA_CUNG_CAP',
    ]).subscribe(t => {
      // Hủy Select2 cũ trước khi khởi tạo lại để tránh trùng lặp
      const ids = ['#fromArea', '#toArea', '#confirmationStatus', '#alertStatus', '#logPP',
        '#typeTemp', '#confirmation', '#classify', '#bash_detail', '#product', '#status',
        '#productId', '#distributionAgent', '#supplier'];
      ids.forEach(id => {
        if ($(id).data('select2')) {
          $(id).select2('destroy');
        }
      });

      $('#fromArea').select2({ placeholder: t['KHU_VUC_XUAT'], allowClear: true });
      $('#toArea').select2({ placeholder: t['KHU_VUC_NHAN'], allowClear: true });
      $('#confirmationStatus').select2({ placeholder: t['TRANG_THAI_XAC_NHAN'], allowClear: true });
      $('#alertStatus').select2({ placeholder: t['TINH_TRANG_CANH_BAO'], allowClear: true });
      $('#logPP').select2({ placeholder: t['KIEU_PHAN_PHOI'], allowClear: true });
      $('#typeTemp').select2({ placeholder: t['HINH_THUC_DONG_GOI'], allowClear: true });
      $('#confirmation').select2({ placeholder: t['TINH_TRANG_XAC_NHAN'], allowClear: true });
      $('#classify').select2({ placeholder: t['PHAN_LOAI'], allowClear: true });
      $('#bash_detail').select2({ placeholder: t['LO_TEM'], allowClear: true });
      $('#product').select2({ placeholder: t['SAN_PHAM'], allowClear: true });
      $('#status').select2({ placeholder: t['TRANG_THAI'], allowClear: true });

      $('#productId').select2({
        placeholder: t['SAN_PHAM'],
        allowClear: true,
        ajax: {
          delay: 1000,
          url: `${environment.api_evs}/products`,
          headers: {
            authorization: localStorage.getItem('Access-Token'),
            'Content-Type': 'application/json',
          },
          dataType: 'json',
          data: function (params) {
            if (params.term) {
              return { name: params.term, offset: 0, limit: 50 };
            }
            return { offset: 0, limit: 50 };
          },
          processResults: function (data) {
            return {
              results: data.data.products.map((item) => ({ text: item.name, id: item.id })),
            };
          },
        },
      });

      $('#distributionAgent').select2({
        placeholder: t['DAI_LY_PHAN_PHOI'],
        allowClear: true,
        ajax: {
          delay: 500,
          url: `${environment.qrcode_url}/agencies`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem('Access-Token')}`,
            'Content-Type': 'application/json',
          },
          dataType: 'json',
          data: function (params) {
            if (params.term) {
              return { name: params.term, offset: 0, limit: 50 };
            }
            return { offset: 0, limit: 50 };
          },
          processResults: (data) => {
            return {
              results: data.data.items.map((item) => ({ text: item.name, id: item.id })),
            };
          },
        },
      });

      $('#supplier').select2({ placeholder: t['CHON_NHA_CUNG_CAP'], allowClear: true });
    });
  }


  listImageDistribution: any = [];

  // delete image upload
  deleteImage2(index: number) {
    this.listImageDistribution.splice(index, 1);
  }

  tusUploadReturnBoxImages2 = (item) => {
    let isValid = true;
    return new Promise((resolve) => {
      for (const image of item.target.files) {
        if (image.type.indexOf('image') === -1) {
          isValid = false;
        }
      }
      resolve(isValid);
    }).then((result) => {
      console.log(result);
      if (result) {
        for (const image of item.target.files) {
          const fileData = new FormData();
          // @ts-ignore
          fileData.append('file', image);
          return this.upload.uploadImagesNew2(fileData).subscribe((response: any) => {
            const res = JSON.parse(response._body)
            if (res.status === 200) {
              const image2 = {
                id: res.data.fileId,
                url: res.data.url,
              };
              this.listImageDistribution.push(image2);
            }
          });

        }
      } else {
        this.toastr.warning(this.translate.instant('KHONG_DUNG_DINH_DANG_ANH'), this.translate.instant('CANH_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      }
    });
  };

  submitFormConfirm(data_post: any) {
    let body = {
      name:
        data_post.name && data_post.name.trim() !== ''
          ? data_post.name
          : null,
      note:
        // tslint:disable-next-line:triple-equals
        data_post.note && data_post.note.trim() != ''
          ? data_post.note
          : null,
      document: {
        items:
          this.listImageDistribution && this.listImageDistribution.length
            ? this.listImageDistribution
            : null,
      },
    }
    console.log('body', body)
    clickTracking('distribute_detail', 'distribute_update_confirm', 'distribute_detail', '')
    this.productRoadmapService.update(this.item_detail.historyId, body).subscribe((res) => {
      console.log(111);
      if (res.code === 1) {
        this.toastr.success(this.translate.instant('SUCCESS_UPDATE'), this.translate.instant('THONG_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
        // this.reset(this.formCratingBatch.value.is_cratingStamps);
        // this.loadDataParent.emit(true);
        this.editStamp.hide();

      } else {
        this.toastr.warning(res.message, this.translate.instant('CANH_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      }
    },
      () => {
        this.toastr.warning(this.translate.instant('ERR_OCCURRED'), this.translate.instant('CANH_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      })
  }

  search() {
    const timePicker = $('.timePicker');
    let distributionAgent = '';
    if (
      $('#distributionAgent').val() === null ||
      isNaN($('#distributionAgent').val())
    ) {
      distributionAgent = '';
    } else {
      distributionAgent = $('#distributionAgent').val();
    }
    this.query = {
      serial: $('.serial').val(),
      fromAgencyId:
        $('#classify').val() == 0 ||
          $('#classify').val() == 3 ||
          !$('#classify').val()
          ? $('#supplier').val()
          : distributionAgent,
      toAgencyId:
        $('#classify').val() == 0 ||
          $('#classify').val() == 3 ||
          !$('#classify').val()
          ? distributionAgent
          : $('#supplier').val(),
      fromProvinceId: $('#fromArea').val(),
      toProvinceId: $('#toArea').val(),
      // confirmationStatus: $('#confirmationStatus').val(),
      type: $('#classify').val(),
      warningType: $('#alertStatus').val(),
      routing: $('#logPP').val(),
      from: timePicker.val().split('-')[0]
        ? timePicker.val().split('-')[0].trim()
        : '',
      to: timePicker.val().split('-')[1]
        ? timePicker.val().split('-')[1].trim()
        : '',
    };
    searchEvent(JSON.stringify(this.query), JSON.stringify(this.query), '', '');
    this.pageIndex = 1;
    this.loading_left = true;
    this.fetch();
  }

  reset() {
    console.log('reset');
    localStorage.removeItem('agencyId');
    this.pageIndex = 1;
    $('.serial').val(null).trigger('change');
    $('#fromArea').val(null).trigger('change');
    $('#toArea').val(null).trigger('change');
    // $('#confirmationStatus').val(null).trigger('change');
    $('#alertStatus').val(null).trigger('change');
    $('#logPP').val(null).trigger('change');
    $('#classify').val(null).trigger('change');
    $('.timePicker').val(null).trigger('change');
    $('#supplier').val(null).trigger('change');
    $('#distributionAgent').val(null).trigger('change');
    this.loading_left = true;

    this.fetch();
  }

  loadDataChild($event: any) {
    this.fetch();
  }

  fetch() {
    const timePicker = $('.timePicker');
    let distributionAgent = '';
    if (
      $('#distributionAgent').val() === null ||
      isNaN($('#distributionAgent').val())
    ) {
      distributionAgent = '';
    } else {
      distributionAgent = $('#distributionAgent').val();
    }
    this.query = {
      serial: $('.serial').val(),
      fromAgencyId:
        $('#classify').val() == 0 ||
          $('#classify').val() == 3 ||
          !$('#classify').val()
          ? $('#supplier').val()
          : distributionAgent,
      toAgencyId:
        $('#classify').val() == 0 ||
          $('#classify').val() == 3 ||
          !$('#classify').val()
          ? distributionAgent
          : $('#supplier').val(),
      fromProvinceId: $('#fromArea').val(),
      toProvinceId: $('#toArea').val(),
      // confirmationStatus: $('#confirmationStatus').val(),
      type: $('#classify').val(),
      warningType: $('#alertStatus').val(),
      routing: $('#logPP').val(),
      from: timePicker.val().split('-')[0]
        ? timePicker.val().split('-')[0].trim()
        : '',
      to: timePicker.val().split('-')[1]
        ? timePicker.val().split('-')[1].trim()
        : '',
      page: this.pageIndex,
      page_size: this.page_size,
    };
    // searchEvent(this.query ? this.query : '', this.query);
    // this.addressService.getCities().subscribe(val => {
    // console.log('val', this.getCities)

    this.productRoadmapService.distributeHistory(this.query).subscribe(
      (res) => {
        if (res.code === 1) {
          this.total_data = res.data.totalElement;

          // console.log(' this.total_data',  this.total_data)
          const listDistribute = [...res.data.items];
          // res.data.items.map((item, key) => {
          //   this.getCities.map((val2) => {
          //     if (item.fromProvinceId === val2.id) {
          //       // tslint:disable-next-line:no-unused-expression
          //       listDistribute[key].fromProvinceId = val2.name;
          //     }
          //     if (item.toProvinceId === val2.id) {
          //       // tslint:disable-next-line:no-unused-expression
          //       listDistribute[key].toProvinceId = val2.name;
          //     }
          //   });
          // });
          this.data = listDistribute;

          if (this.data.length > 0) {
            this.data.map((item, i) => {
              if (i === 0) {
                this.viewDetail(item, i);
              }
            });
          }
          this.loading_left = false;
          return;
        }
        this.total_data = 0;
        this.loading_left = false;
        this.data = [];
        this.toastr.warning(res.message, this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
      },
      (err) => {
        this.total_data = 0;
        this.loading_left = false;
        this.data = [];
        this.toastr.warning(err.message, this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
      }
    );
  }

  getFromArea() {
    this.addressService.getCities().subscribe((res) => {
      const citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
      });
      this.fromArea = citiesList;
      this.toArea = citiesList;
      this.getCities = res.data.cities;

      this.fetch();
    });
  }

  changeReadMore(e) {
    this.isReadmore = e;
  }

  viewDetailTracking(i) {
    visibleContent('qcheck_distribute_history', 'distribute_detail', '')
    clickTracking('qcheck_distribute_history', 'distribute_log', 'distribute_detail', this.historyId);
  }

  // tslint:disable-next-line:member-ordering
  public toLocation = [];
  public viewDetailItem;

  viewDetail(item, i) {
    this.transfer_id = item.historyId
    this.resetFormWithdrawal()
    this.resetCheckbox();
    this.activeTab = 1;
    this.formStamp.reset();
    $('.stampCode').val('').trigger('change');
    $('#typeTemp').val(null).trigger('change');
    $('#productId').val(null).trigger('change');
    $('#confirmation').val(null).trigger('change');
    // $('#stampStatus').val(null).trigger('change');
    this.pageIndexStamp = 1;

    this.item_active = i;
    this.viewDetailItem = item;
    this.productRoadmapService
      .statisticHistory(item.historyId)
      .subscribe((res) => {
        this.stasitic = res.data;
        // console.log('kkk', this.stasitic)
      });
    // this.addressService.getCities().subscribe(val => {

    // @ts-ignore
    this.productRoadmapService
      .distributeDetail(item.historyId)
      .subscribe((res) => {
        const listDistribute = res.data;
        this.canUpdateAgency = res.data.canUpdateAgency

        // tslint:disable-next-line:no-shadowed-variable
        // this.getCities.map((val2) => {
        //   if (listDistribute.fromProvinceId === val2.id) {
        //     // tslint:disable-next-line:no-unused-expression
        //     listDistribute.fromProvinceId = val2.name;

        //     this.addressService
        //       .getDistrict({ city_id: val2.id })
        //       .toPromise()
        //       .then((res1) => {
        //         res1.data.districts.forEach((c: any) => {
        //           if (c.id === listDistribute.fromDistrictId) {
        //             listDistribute.fromDistrictId = c.name;
        //           }
        //         });
        //       });
        //   }
        //   if (listDistribute.toProvinceId === val2.id) {
        //     // tslint:disable-next-line:no-unused-expression
        //     listDistribute.toProvinceId = val2.name;
        //     this.addressService
        //       .getDistrict({ city_id: val2.id })
        //       .toPromise()
        //       .then((res1) => {
        //         res1.data.districts.forEach((c: any) => {
        //           if (c.id === listDistribute.toDistrictId) {
        //             listDistribute.toDistrictId = c.name;
        //           }
        //         });
        //       });
        //   }
        // });
        this.item_detail = listDistribute;
        this.toLocation = []
        const arr = [];
        listDistribute.toLocation.map((res) => {
          const address = res.toAddress ? res.toAddress + ' - ' : '';
          const toDistrictArea = res.toDistrictArea ? res.toDistrictArea : '';
          const toProvincesArea = res.toProvincesArea ? res.toProvincesArea : '';
          const result = address + toDistrictArea + ' - ' + toProvincesArea;
          arr.push(result)
        })
        this.toLocation = arr
        console.log('res', this.toLocation)
        this.formCratingBatch.controls.name.setValue(this.item_detail.name);
        this.formCratingBatch.controls.note.setValue(this.item_detail.note);
        this.listImageDistribution = [];
        if (this.item_detail.document && this.item_detail.document.items) {
          this.item_detail.document.items.map((res) => {
            this.listImageDistribution.push({
              id: res.id,
              url: res.url,
            })
          })
        }

        // listImageDistribution
      });
    if (this.isDistribution === true) {
      this.toastr.warning(this.translate.instant('DA_DONG_GIAO_DIEN_PHAN_PHOI'), this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
    }

    if (this.isWithdrawal === true) {
      this.listContent = [];
      this.stampList = [];
      this.errorMessage = [];
      this.toastr.warning(this.translate.instant('DA_DONG_GIAO_DIEN_THU_HOI'), this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
    }
    this.isDistribution = false;
    this.isWithdrawal = false;
    this.isList = true;
    this.historyId = item.historyId;

    console.log(123444);
    this.loadListStamp();
  }

  changeDistribution() {
    if (this.loading_left) {
      this.toastr.warning(this.translate.instant('DANG_TAI_DU_LIEU'), this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
    } else {
      clickTracking('qcheck_distribute_history', 'btn_distribute', 'qcheck_stamp_distribute', '');
      visibleContent('qcheck_distribute_history', 'qcheck_stamp_distribute', '')
      this.isDistribution = true;
      this.isList = false;
      this.isWithdrawal = false;
      this.resetFormWithdrawal()

    }
  }

  // load page danh sach lịch sử đóng thùng
  prePageList() {
    if (this.pageIndex > 1) {
      this.pageIndex = this.pageIndex - 1;
      this.loading_left = true;

      this.fetch();
    }
  }

  lastPageList() {
    // console.log('res.items', this.pageIndex * this.page_size, this.total_data )

    // if (this.pageIndex * this.page_size < this.total_data) {
    this.pageIndex = this.pageIndex + 1;
    this.loading_left = true;

    this.fetch();
    // }
  }

  inputPageList(event) {
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndex) {
      this.pageIndex = page;
      this.loading_left = true;

      this.fetch();
    }
  }

  // ============== danh sach tem ========================== //
  loadListStamp() {
    // this.queryStamp
    this.loading_stamp = true;
    let productId = '';
    if ($('#productId').val() === null || isNaN($('#productId').val())) {
      productId = '';
    } else {
      productId = $('#productId').val();
    }
    this.queryStamp = {
      stampCode: $('.stampCode').val(),
      // stampType: $("#typeTemp").val(),
      // stampStatus: $('#stampStatus').val(),
      status: $('#confirmation').val(),
      productId: productId,
      page: this.pageIndexStamp,
      page_size: this.pageSizeStamp,
      box_type: $('#typeTemp').val(),
    };
    this.productRoadmapService
      .historyPackage(this.historyId, this.queryStamp)
      .subscribe(
        (res) => {
          console.log('res phan phoi:', res.data.items);
          if (res.code === 1) {
            this.data_stamp = res.data.items.map((item: any) => {
              let tmpItem = item;
              tmpItem.serialStart = this.formatSerial(
                item.idStart,
                item.prefix
              );
              tmpItem.serialEnd = this.formatSerial(item.idEnd, item.prefix);

              return tmpItem;
            });
            this.total_stamp = res.data.totalElement;
            this.refeshCheckAll();
            this.loading_stamp = false;
            return;
          }
          this.data_stamp = [];
          this.total_stamp = 0;
          this.loading_stamp = false;
        },
        (error) => {
          this.data_stamp = [];
          this.total_stamp = 0;
          this.loading_stamp = false;
        }
      );
  }

  refeshCheckAll() {
    if (this.data_stamp && this.data_stamp.length) {
      // tslint:disable-next-line:max-line-length
      this.isCheckAll = this.data_stamp.every(
        (item) =>
          this.listOfChecked[
          item.stampId +
          '-' +
          item.stampStatus +
          '-' +
          item.stampType +
          '-' +
          item.prefix +
          '-' +
          item.idStart +
          '-' +
          item.idEnd
          ]
      );
      return;
    }
    this.isCheckAll = false;
  }

  searchStamp() {
    this.pageIndexStamp = 1;
    this.loadListStamp();
  }

  resetStamp() {
    this.formStamp.reset();
    $('.stampCode').val('').trigger('change');
    $('#typeTemp').val(null).trigger('change');
    $('#productId').val(null).trigger('change');
    $('#confirmation').val(null).trigger('change');
    // $('#stampStatus').val(null).trigger('change');
    this.pageIndexStamp = 1;
    this.loadListStamp();
  }

  checkALl(event) {
    this.isCheckAll = event.target.checked;
    if (this.isCheckAll) {
      this.data_stamp.map((item) => {
        // tslint:disable-next-line:max-line-length
        this.listOfChecked[
          item.stampId +
          '-' +
          item.stampStatus +
          '-' +
          item.stampType +
          '-' +
          item.prefix +
          '-' +
          item.idStart +
          '-' +
          item.idEnd
        ] = true;
      });
      this.listIdChecked();
      this.checkDisableButton();

      return;
    }
    this.data_stamp.map((item) => {
      // tslint:disable-next-line:max-line-length
      this.listOfChecked[
        item.stampId +
        '-' +
        item.stampStatus +
        '-' +
        item.stampType +
        '-' +
        item.prefix +
        '-' +
        item.idStart +
        '-' +
        item.idEnd
      ] = false;
      this.listIdChecked();
      this.checkDisableButton();
    });
  }

  listIdChecked() {
    for (const key in this.listOfChecked) {
      if (this.listOfChecked[key] === true) {
        if (!this.list_id.includes(key)) {
          this.list_id.push(key);
        }
      } else {
        if (this.list_id.includes(key)) {
          this.list_id.splice(this.list_id.indexOf(key), 1);
        }
      }
    }
  }

  checkBoxChange(event) {
    const checked = event.target.checked;
    const value = event.target.value;
    console.log('tuanba ' + checked);
    this.listOfChecked[value] = checked;
    console.log('tuanba value: ' + JSON.stringify(this.listOfChecked));
    // tslint:disable-next-line:max-line-length
    this.isCheckAll = this.data_stamp.every(
      (item) =>
        this.listOfChecked[
        item.stampId +
        '-' +
        item.stampStatus +
        '-' +
        item.stampType +
        '-' +
        item.prefix +
        '-' +
        item.idStart +
        '-' +
        item.idEnd
        ]
    );
    this.listIdChecked();
    this.checkDisableButton();
  }

  resetCheckbox() {
    this.isCheckAll = false;
    this.listOfChecked = {};
    this.list_id = [];
    this.disabledConfirm = false;
    this.disabledReturnBox = false;
    this.disabledTakeBack = false;
  }

  checkDisableButton() {
    // check disable button
    const checkConfirm = [];
    const checkReturn = [];
    const checkTakeBack = [];
    this.list_id.map((res) => {
      const stampStatus = res.split('-')[1];
      const stamp = res.split('-')[0];
      // tslint:disable-next-line:radix
      if (parseInt(stampStatus) === 1) {
        console.log('stampStatus1', stampStatus);
        checkConfirm.push(stamp);
        checkTakeBack.push(stamp);
      } else {
        console.log('stampStatus2', stampStatus);

        checkReturn.push(stamp);
      }
    });

    this.disabledConfirm = checkConfirm.length > 0;
    this.disabledReturnBox = checkReturn.length > 0;
    this.disabledTakeBack = checkTakeBack.length > 0;
  }

  confirmAll(e?) {
    clickTracking('distribute_detail', 'stamp_confirm', 'distribute_detail', '');
    let body = {};

    if (e) {
      body = {
        listBundleId: [e],
      };
    } else {
      if (this.list_id.length <= 0) {
        this.toastr.warning(this.translate.instant('CHUA_CHON_TEM'), this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
        return;
      }
      const list = [];
      this.list_id.map((res) => list.push(res.split('-')[0]));

      body = {
        listBundleId: list,
      };
    }

    console.log('this.listOfChecked', body);

    this.productRoadmapService.confirm(body).subscribe(
      (res) => {
        console.log('res111kkk', res);
        if (res.code === 1) {

          this.isCheckAll = false;
          this.listOfChecked = {};
          this.list_id = [];
          this.loadListStamp();

          this.toastr.success(
            this.translate.instant('XAC_NHAN_THANH_CONG') +
            `<div>${this.translate.instant('THANH_CONG')}: <b>${res.data.success}</b>, ${this.translate.instant('THAT_BAI')}: <b>${res.data.fail}</b></div>`,
            this.translate.instant('THANH_CONG'),
            {
              timeOut: 4000,
              positionClass: 'toast-top-right',
              enableHtml: true,
            }
          );
          return;
        }
        this.toastr.warning(res.message, this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
      },
      (error) => {
        this.toastr.warning(error.message, this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
      }
    );
  }

  returnBox() {
    clickTracking('distribute_detail', 'stamp_return', 'distribute_detail', '')
    console.log(this.singleReturnBox, _.isEmpty(this.singleReturnBox));

    if (_.isEmpty(this.singleReturnBox)) {
      if (this.list_id.length <= 0) {
        this.toastr.warning(this.translate.instant('CHUA_CHON_TEM'), this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
        return;
      }
    }
    this.returnStampBox.show();
  }

  loadingReturnStampBox: boolean = false;

  handleReturnStampBox() {
    console.log('this.list_id', this.list_id);
    if (this.addContent.trim().length === 0) {
      this.toastr.warning(this.translate.instant('CHUA_NHAP_LY_DO_TRA_HANG'), this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
      return;
    }
    if (this.addContent.trim().length > 255) {
      this.toastr.warning(this.translate.instant('NHAP_QUA_255_KY_TU'), this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
      return;
    }

    let body = {};
    // trả hàng nhiều
    if (_.isEmpty(this.singleReturnBox)) {
      const data = [];
      this.list_id.map((res) => {
        let arrSplit = res.split('-');
        const stampType = arrSplit[2];
        const idEnd = arrSplit[arrSplit.length - 1];
        const idStart = arrSplit[arrSplit.length - 2];
        const indexRemove = [0, 1, 2, arrSplit.length - 1, arrSplit.length - 2];
        const prefix = arrSplit
          .filter(function (value, index) {
            return indexRemove.indexOf(index) == -1;
          })
          .join('-');

        data.push({
          type: stampType,
          prefix: prefix,
          idStart: idStart,
          idEnd: idEnd,
          note: this.addContent,
          document: {
            items:
              this.returnStampBoxImages && this.returnStampBoxImages.length
                ? this.returnStampBoxImages
                : null,
          },
        });
      });
      body = {
        listData: data,
        transferId: this.historyId,
      };
    }
    // trả hàng đơn
    else {
      body = {
        transferId: this.historyId,
        listData: [
          {
            type: this.singleReturnBox['stampType'],
            prefix: this.singleReturnBox['prefix'],
            idStart: this.singleReturnBox['idStart'],
            idEnd: this.singleReturnBox['idEnd'],
            note: this.addContent,
            document: {
              items:
                this.returnStampBoxImages && this.returnStampBoxImages.length
                  ? this.returnStampBoxImages
                  : null,
            },
          },
        ],
      };
    }

    this.loadingReturnStampBox = true;
    this.productRoadmapService.return(body).subscribe(
      (res) => {
        if (res.code === 1) {
          this.list_id = [];
          this.listOfChecked = {};
          this.isCheckAll = false;
          this.toastr.success(
            this.translate.instant('TRA_HANG_THANH_CONG') +
            `<div>${this.translate.instant('THANH_CONG')}: <b>${res.data.success}</b>, ${this.translate.instant('THAT_BAI')}: <b>${res.data.fail}</b></div>`,
            this.translate.instant('THANH_CONG'),
            {
              timeOut: 4000,
              enableHtml: true,
            }
          );
          this.loadingReturnStampBox = false;
          setTimeout(() => {
            this.addContent = '';
            this.returnStampBoxImages = [];
            this.returnStampBox.hide();
            this.loadListStamp();
          }, 200);
          return;
        }
        this.loadingReturnStampBox = false;
        this.toastr.error(`${res.message}`, this.translate.instant('THAT_BAI'));
      },
      (error) => {
        this.loadingReturnStampBox = false;
        this.toastr.error(`${error.message}`, this.translate.instant('THAT_BAI'));
      }
    );
  }

  takeBack() {
    clickTracking('distribute_detail', 'stamp_retrieve', 'distribute_detail', '');
    if (_.isEmpty(this.singleTakeBack)) {
      if (this.list_id.length <= 0) {
        this.toastr.warning(this.translate.instant('CHUA_CHON_TEM'), this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
        return;
      }
    }
    this.returnStamp.show();
    // visibleContent('qcheck_distribute_history', 'qcheck_stamp_retrieve')
  }


  cancel() {
    clickTracking('distribute_detail', 'distribute_cancel', 'form_distribute_cancel', '')
    this.cancelStamp.show();
    visibleContent('distribute_detail', 'form_distribute_cancel', '')
  }

  showEdit() {
    clickTracking('distribute_detail', 'distribute_update', 'form_distribute_update', '')
    this.editStamp.show();
    this.boxStampDistribution.setData3(this.item_detail)

    visibleContent('distribute_detail', 'form_distribute_update', '')
  }

  showEditModal = true;

  onReloadEditModal() {
    this.editStamp.hide();
    setTimeout(() => {
      this.showEditModal = false;
      setTimeout(() => {
        this.showEditModal = true;
      });
    }, 500);

    this.viewDetail(this.viewDetailItem, this.item_active)

  }

  onLoadingReturnStamp: boolean = false;

  handleReturnStamp() {
    clickTracking('qcheck_stamp_retrieve', 'retrieve_submit', 'qcheck_distribute_history', '');
    let body = {};
    if (_.isEmpty(this.singleTakeBack)) {
      const data = [];
      this.list_id.map((res) => {
        const stampId = res.split('-')[0];
        data.push({
          bundleId: stampId,
        });
      });

      body = {
        datas: data,
        transferId: this.historyId,
      };
    } else {
      body = {
        datas: [this.singleTakeBack],
        transferId: this.historyId,
      };
    }
    console.log('body tuan', this.data_stamp);
    this.onLoadingReturnStamp = true;
    this.productRoadmapService.takeBack(body).subscribe(
      (res) => {
        if (res.code === 1) {
          this.list_id = [];
          this.listOfChecked = {};
          this.isCheckAll = false;
          this.toastr.success(
            this.translate.instant('THU_HOI_PHAN_PHOI_THANH_CONG') +
            `<div>${this.translate.instant('THANH_CONG')}: <b>${res.data.success}</b>, ${this.translate.instant('THAT_BAI')}: <b>${res.data.fail}</b></div>`,
            this.translate.instant('THANH_CONG'),
            {
              timeOut: 4000,
              enableHtml: true,
            }
          );
          setTimeout(() => {
            this.returnStamp.hide();
            this.loadListStamp();
          }, 200);
          this.onLoadingReturnStamp = false;
          return;
        }
        this.toastr.error(`${res.message}`, this.translate.instant('THAT_BAI'));
        this.onLoadingReturnStamp = false;
      },
      (error) => {
        this.onLoadingReturnStamp = false;
        this.toastr.error(`${error.message}`, this.translate.instant('THAT_BAI'));
      }
    );
  }

  onloadingCancelStamp: boolean = false;

  handleCancelStamp() {
    let body = {
      transferId: this.item_detail.historyId
    }
    this.onloadingCancelStamp = true;
    clickTracking('form_distribute_cancel', 'distribute_cancel_confirm', 'qcheck_distribute_history', '')
    this.productRoadmapService.cancelStamp(body).subscribe(
      (res: any) => {
        console.log(res);
        if (res.code === 1) {
          this.toastr.success(this.translate.instant('HUY_GIAO_DICH_THANH_CONG'), this.translate.instant('THANH_CONG'), {
            timeOut: 4000,
            enableHtml: true,
          });
          setTimeout(() => {
            this.cancelStamp.hide();
            // this.loadListStamp();
            this.reset()
          }, 200);
          this.onloadingCancelStamp = false;
          return;
        }
        this.toastr.error(`${res.message}`, this.translate.instant('THAT_BAI'));
        this.onloadingCancelStamp = false;
      },
      (error) => {
        this.onloadingCancelStamp = false;
        this.toastr.error(`${error.message}`, this.translate.instant('THAT_BAI'));
      }
    );
  }

  prePageStamp() {
    this.pageIndexStamp = this.pageIndexStamp - 1;
    this.loadListStamp();
  }

  lastPageStamp() {
    if (this.pageIndexStamp * this.pageSizeStamp < this.total_stamp) {
      this.pageIndexStamp = this.pageIndexStamp + 1;
      this.loadListStamp();
    }
  }

  inputPageStamp(event) {
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexStamp) {
      this.pageIndexStamp = page;
      this.loadListStamp();
    }
  }

  // search serial
  searchInfoSerial(code: string) {
    this.router.navigate(['/find-stamp'], { queryParams: { code } });
  }

  formatSerial(id: any, prefix: string) {
    let serial_f: string = '';
    id = id.toString();
    if (id && prefix) {
      let pad = '000000';
      let serial = pad.substring(0, 6 - id.length) + id;
      serial_f = prefix + '-' + serial;
    }
    return serial_f;
  }

  // handle images when upload
  tusUploadReturnBoxImages = (item) => {
    const numberImages = item.target.files.length;
    for (const image of item.target.files) {
      const fileData = new FormData();
      // @ts-ignore
      fileData.append('file', image);
      return this.upload.uploadImagesNew2(fileData).subscribe((response: any) => {
        const res = JSON.parse(response._body)
        if (res.status === 200) {
          const image2 = {
            id: res.data.fileId,
            url: res.data.url,
          };
          this.returnStampBoxImages.push(image2);

        }
      });


    }
  };

  // delete image upload
  deleteImage(index: number) {
    this.returnStampBoxImages.splice(index, 1);
  }

  getListBoxType() {
    this.productRoadmapService.listBoxType().subscribe(
      (res) => {
        if (res.code === 1) {
          this.boxTypeList = res.data.map((item) => {
            return {
              value: item.type,
              label: item.name,
            };
          });
        } else {
          this.boxTypeList = [];
        }
      },
      (err) => {
        this.boxTypeList = [];
        console.log(err);
      }
    );
  }

  activeTab = 1;
  pageIndexWarningUser = 1;
  pageSizeWarningUser = 10;
  total_warning_user = 0;
  loadingUserWarning: boolean = false;
  data_warning_user = [];

  changeTab(event) {
    this.activeTab = event;
    if (event === 1) {
      // this.resetWarningAuto();
    }
    if (event === 2) {
      // this.resetInspection();
    }
    if (event === 3) {
      this.resetWarningUser();
    }
    /** Thống kê lịch sử xuất hàng */
    if (event === 4) {
      this.getStatisticHistoryProduct();
    }
    /** Thống kê lịch sử nhập hàng */
    if (event === 5) {
      this.getStatisticHistoryProduct();
    }

    // this.districts = [];
  }

  data_statistic_history_product;

  getStatisticHistoryProduct() {
    this.productRoadmapService.statisticHistoryProduct(this.historyId).subscribe((res) => {
      if (res.code === 1) {
        if (res.data.produce === null) {
          this.data_statistic_history_product = res.data.consume;
        } else {
          this.data_statistic_history_product = res.data.produce;
          console.log(this.data_statistic_history_product.distribution)
          console.log('res statitic', this.data_statistic_history_product.distribution)
        }

      } else {
        this.toastr.error(res.message, this.translate.instant('THAT_BAI'))
      }
    },
      (error) => {
        this.toastr.error(`${error.message}`, this.translate.instant('THAT_BAI'));
      })
  }

  resetWarningUser() {
    this.pageIndexWarningUser = 1;
    // $("#Area3").val("").trigger("change");
    // $("#Agency3").val("").trigger("change");
    this.loadDataWarningUser();
  }

  searchWarningUser() {
    this.pageIndexWarningUser = 1;
    this.loadDataWarningUser();
  }

  loadDataWarningUser() {
    let query: any = {
      // keySearch:
      //   $('#serial3').val() && $('#serial3').val().trim() !== ''
      //     ? $('#serial3').val().trim().toUpperCase()
      //     : '',
      // agency: $('#Agency3').val() || '',
      // province: $('#Area3').val() || '',
      from: '',
      to: '',
      page: this.pageIndexWarningUser,
      page_size: this.pageSizeWarningUser,
    };
    // let time = $('#time3').val();
    // if (time) {
    //   query.from = time.split('-')[0].split('/').join('-').trim();
    //   query.to = time.split('-')[1].split('/').join('-').trim();
    // }

    this.loadingUserWarning = true;
    this.productRoadmapService.getList(this.historyId, query).subscribe(
      (res) => {
        console.log('res', res)
        if (res.code === 1) {
          if (
            res.data.items !== null ||
            (res.data.items && res.data.items.length > 0)
          ) {
            this.data_warning_user = res.data.items.map((item: any) => {
              const tmpItem = Object.assign({}, item);
              let serial: any;
              if (item.stampCode && item.stampCode.split('-').length) {
                serial = this.formatSerial(
                  item.stampCode.split('-')[1],
                  item.stampCode.split('-')[0]
                );
                tmpItem.serial = serial;
              }

              return tmpItem;
            });
            this.total_warning_user = res.data.totalElement;
            this.loadingUserWarning = false;
            return;
          } else {
            this.data_warning_user = [];
            this.loadingUserWarning = false;
            this.total_warning_user = 0;
          }
        }
        this.data_warning_user = [];
        this.loadingUserWarning = false;
        this.total_warning_user = 0;
      },
      (error) => {
        this.data_warning_user = [];
        this.total_warning_user = 0;
        this.loadingUserWarning = false;
      }
    );
  }

  prePageWarningUser() {
    if (this.pageIndexWarningUser > 1) {
      this.pageIndexWarningUser = this.pageIndexWarningUser - 1;
      this.loadDataWarningUser();
    }
  }

  lastPageWarningUser() {
    if (
      this.pageIndexWarningUser * this.pageSizeWarningUser <
      this.total_warning_user
    ) {
      this.pageIndexWarningUser = this.pageIndexWarningUser + 1;
      this.loadDataWarningUser();
    }
  }

  inputPageWarningUser(event) {
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexWarningUser) {
      this.pageIndexWarningUser = page;
      this.loadDataWarningUser();
    }
  }

  listContent = [];
  stampList = [];
  @ViewChild('boxRetalStamps') boxRetalStamps;
  errorMessage = [];
  // groupItems = [];
  isWithdrawal = false

  isNaN(x) {
    // Ép kiểu Number cho biến x
    x = Number(x);
    // Nếu x là NaN, NaN != NaN trả về true, các trường hợp khác sẽ trả về false
    return x != x;
  }

  removeItem(index) {
    this.listContent = this.listContent.filter((res, i) => i !== index);
    this.stampList = this.stampList.filter((res, i) => i !== index);
    console.log(' this.listContent', this.listContent)
    console.log(' this.stampList', this.stampList)

    if (this.stampList.length == 0) {
      this.errorMessage = [];
    } else {
      console.log(' this.stampList', this.stampList)
      console.log('this.errorMessage', this.errorMessage)

      const convertListContent = []
      this.listContent.map((item) => {
        const prefix = item.split('-')[0]
        const number = Number(item.split('-')[1])
        console.log('item', item)
        console.log('prefix', prefix)
        convertListContent.push(`${prefix}-${number}-${number}`)

      })
      this.errorMessage = this.errorMessage.filter((val) => {
        if (val.parent) {
          if (convertListContent.includes(val.parent)) {
            return convertListContent.includes(val.serial)

          } else {
            return false
          }
        } else {
          return convertListContent.includes(val.serial)
        }
      })
    }
    // this.validateWithdrawal()

  }

  showModal() {
    // console
    const data = {
      id: 'myModalCrating',
      title: this.translate.instant('THEM_DANH_SACH_TEM_THU_HOI'),
      contentMess: this.translate.instant('BAN_CHUA_NHAP_TEM'),
      listContent: [],
    };
    this.boxRetalStamps.show(data);
  }

  loadDataTH(e) {
    console.log('e', e);

    const stampList = [];
    e.map((res) => {
      const splitSerial = res.split('-');
      let _serial: any = '';
      let _prefix: any = '';
      if (splitSerial.length > 1) {
        _serial = splitSerial.pop();
        _prefix = splitSerial[0];
      } else {
        _serial = NaN;
        _prefix = splitSerial[0];
      }
      const stamp = {
        prefix: _prefix,
        serialFirst: _serial,
        serialLast: _serial,
      };
      stampList.push(stamp);
    });
    // this.stampList = stampList;
    // console.log(' this.stampList', this.stampList)
    this.validateWithdrawal(stampList)
  }

  timeout: any = null;
  checkboxSigle: false

  changeCheckboxSigle() {
    this.checkboxSigle = $('#checkboxSigle').is(':checked')
    setTimeout(() => {
      $('#checkboxSigleVal').focus()
    }, 500)
  }

  changeCheckboxSigleValue() {

    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    this.timeout = setTimeout(() => {
      console.log('asdfas', $('#checkboxSigleVal').val())

      let id = '';
      if ($('#checkboxSigleVal').val().search('http') !== -1) {
        const splitLink = $('#checkboxSigleVal').val().split('/')
        id = splitLink[splitLink.length - 1]
      } else {
        id = $('#checkboxSigleVal').val()
      }

      if (id) {
        console.log('id', id)

        this.productRoadmapService
          .detailStamp(id)
          .subscribe((val) => {
            if (val.code === 1) {
              this.loadDataTH([val.data])
            } else {
              this.toastr.warning(this.translate.instant('TEM_KHONG_HOP_LE'), this.translate.instant('CANH_BAO'), {
                timeOut: 3000,
                positionClass: 'toast-top-right',
              });
            }
            console.log('val', val)
          })
      } else {
        this.toastr.warning(this.translate.instant('TEM_KHONG_HOP_LE'), this.translate.instant('CANH_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      }
      $('#checkboxSigleVal').val('')

    }, 200);
  }

  changeWithdrawal() {
    if (this.loading_left) {
      this.toastr.warning(this.translate.instant('DANG_TAI_DU_LIEU'), this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
    } else {
      this.isDistribution = false;
      this.isList = false;
      this.isWithdrawal = true;
      clickTracking('qcheck_distribute_history', 'retrieve', 'qcheck_stamp_retrieve', '');
      visibleContent('qcheck_distribute_history', 'qcheck_stamp_retrieve', '')
    }
  }

  validateWithdrawal(stampList) {
    // console.log(111, this.stampList);
    if (stampList.length <= 0) {
      this.toastr.warning(this.translate.instant('BAN_CHUA_NHAP_TEM'), this.translate.instant('CANH_BAO'), {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      return;
    }

    let body = [];
    // this.errorMessage = [];
    stampList.map((res) => {
      body.push({
        prefix: res.prefix,
        idStart: Number(res.serialFirst),
        idEnd: Number(res.serialLast)
      })
    })

    console.log('body', body);
    this.productRoadmapService.validateWithdrawal(body).subscribe(
      (res) => {
        console.log(111);
        // this.stampList = []
        res.data.items.map((val) => {
          let check = _.find(this.stampList, {
            prefix: val.takeBackData.prefix,
            serialFirst: val.takeBackData.idStart,
            serialLast: val.takeBackData.idEnd,
            bundleType: val.bundleType,
            listParent: val.listParent,
            takeBackData: val.takeBackData,
            errMsg: val.errMsg,

          })
          if (!check) {
            this.listContent.push(val.takeBackData.stampRequest);
            console.log('this.listContent', this.listContent)
            console.log('val.takeBackData.stampRequest', val.takeBackData.stampRequest)
            this.stampList.push({
              prefix: val.takeBackData.prefix,
              serialFirst: val.takeBackData.idStart,
              serialLast: val.takeBackData.idEnd,
              bundleType: val.bundleType,
              listParent: val.listParent,
              takeBackData: val.takeBackData,
              errMsg: val.errMsg,

            })
          } else {
            this.toastr.warning(`Tem ${val.takeBackData.stampRequest} đã tồn tại trong dải ${val.takeBackData.prefix}-${val.takeBackData.idStart}-${val.takeBackData.idEnd}`, this.translate.instant('CANH_BAO'), {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
          }

        })
        console.log(' this.stampList', this.stampList);
        // check trung temp
        const err = []
        this.stampList.map((itemVal) => {
          if (res.code === 1) {
            if (itemVal.errMsg) {
              err.push({
                parent: '',
                serial: `${itemVal.takeBackData.prefix}-${itemVal.takeBackData.idStart}-${itemVal.takeBackData.idEnd}`,
                mess: `${itemVal.errMsg}`,
              })
            }
          }

          if (itemVal.listParent.length > 0) {
            itemVal.listParent.map((itemParent) => {
              const checkTr = _.find(this.stampList, {
                'prefix': itemParent.prefix,
                'serialFirst': itemParent.number,
                'serialLast': itemParent.number
              });
              if (checkTr) {
                err.push({
                  parent: `${itemParent.prefix}-${itemParent.number}-${itemParent.number}`,
                  serial: `${itemVal.takeBackData.prefix}-${itemVal.takeBackData.idStart}-${itemVal.takeBackData.idEnd}`,
                  mess: `Tem con ${itemVal.takeBackData.prefix}-${itemVal.takeBackData.idStart}-${itemVal.takeBackData.idEnd} đã thuộc Tem cha ${itemParent.prefix}-${itemParent.number}-${itemParent.number}`,
                })
              }
              console.log('checkTr', checkTr)

            })
          }
          this.errorMessage = err
        })

        if (res.code === 1) {
          // this.stampList.map((val) => {
          //   if (val.errMsg) {
          //     this.errorMessage.push({
          //       serial: `${val.takeBackData.stampRequest}`,
          //       mess: `${val.errMsg}`,
          //     })
          //   }
          //
          // })


          // this.stampList = stampList;
          // if (this.errorMessage.length === 0) {
          //   this.listContent = [];
          //   this.stampList = [];
          //   this.toastr.success(this.translate.instant('SUCCESS_UPDATE'), this.translate.instant('THONG_BAO'), {
          //     timeOut: 3000,
          //     positionClass: 'toast-top-right',
          //   });
          // }

          // this.reset(this.formCratingBatch.value.is_cratingStamps);
          // this.loadDataParent.emit(true);
        } else {
          this.toastr.warning(res.message, this.translate.instant('CANH_BAO'), {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
        }
      },
      (error) => {
        this.toastr.warning(`${error.message}`, this.translate.instant('CANH_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      }
    );
    // }
  }

  takeBackList() {
    console.log(12312312312312);
    // if (_.isEmpty(this.singleTakeBack)) {
    //   if (this.list_id.length <= 0) {
    //     this.toastr.warning(this.translate.instant('CHUA_CHON_TEM'), this.translate.instant('THONG_BAO'), {
    //       timeOut: 4000,
    //       positionClass: 'toast-top-right',
    //     });
    //     return;
    //   }
    // }
    clickTracking('qcheck_stamp_retrieve', 'retrieve_submit', 'qcheck_distribute_history', '')
    this.returnStampList.show();
  }

  resetFormWithdrawal() {
    this.formWithdrawal.reset();
    this.checkboxSigle = false
    this.listContent = [];
    this.stampList = [];
    this.errorMessage = [];
  }

  submitFormWithdrawal() {
    console.log(111, this.stampList);
    if (this.stampList.length <= 0) {
      this.toastr.warning(this.translate.instant('BAN_CHUA_NHAP_TEM'), this.translate.instant('CANH_BAO'), {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      return;
    }
    if (this.errorMessage.length > 0) {
      this.toastr.warning(this.translate.instant('TEM_LOI_CHUA_DUOC_XU_LY'), this.translate.instant('THONG_BAO'), {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      return;
    }
    let body = [];
    this.stampList.map((res) => {
      body.push({
        prefix: res.prefix,
        idStart: Number(res.serialFirst),
        idEnd: Number(res.serialLast),
        bundleType: Number(res.bundleType)

      })
    })

    console.log('body', body);
    // return;
    this.productRoadmapService.withdrawal({ items: body }).subscribe(
      (res) => {
        if (res.code === 1) {
          this.returnStampList.hide()
          this.listContent = [];
          this.stampList = [];
          if (res.data.fail > 0) {
            this.toastr.warning(`Cập nhật thành công ${res.data.success}, thất bại ${res.data.fail}`, this.translate.instant('CANH_BAO'), {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
          } else {
            this.toastr.success(`Cập nhật thành công ${res.data.success}, thất bại ${res.data.fail}`, this.translate.instant('THONG_BAO'), {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
          }

          this.formWithdrawal.reset();
        } else {
          this.toastr.warning(res.message, this.translate.instant('CANH_BAO'), {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
        }
      },
      (error) => {
        this.toastr.warning(`${error.message}`, this.translate.instant('CANH_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      }
    );
    // }
  }

  bsModalDownload: BsModalRef;

  showDownloadBatch(templateDownload) {
    this.bsModalDownload = this.modalService.show(templateDownload);
  }

  // Export Alert
  public messageExport: any = '';

  exportAlert(type: string) {
    this.messageExport = '';

    const timePicker = $('.timePicker2');
    let timeData = {
      startDate: timePicker.val().split('-')[0]
        ? timePicker.val().split('-')[0].trim()
        : '',
      endDate: timePicker.val().split('-')[1]
        ? timePicker.val().split('-')[1].trim()
        : '',
    };

    if (!timePicker.val()) {
      this.toastr.warning(this.translate.instant('CHUA_CHON_THOI_GIAN'), this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
      return;
    }

    const body = {
      exportTypeEnum: type,
      fields: timeData
    };

    console.info(body);

    this.exportService
      .exportReport(body)
      .subscribe((res) => {
        if (res.code == 1) {
          this.messageExport = this.translate.instant('HE_THONG_DANG_XU_LY');
          $('.stampBoxStampAlertAdd').css('opacity', '1');
          setTimeout(() => {
            $('.stampBoxStampAlertAdd').css('opacity', '0');
          }, 5000);
        } else {
          this.toastr.error(this.translate.instant('CO_LOI_XAY_RA'), this.translate.instant('THONG_BAO'), {
            timeOut: 3000,
            positionClass: 'toastr-bottom-right'
          })
        }
      }, (error) => {
        this.toastr.error(error.message, this.translate.instant('THONG_BAO'), {
          timeOut: 3000,
          positionClass: 'toastr-bottom-right'
        })
      });

    this.bsModalDownload.hide();
  }

  downloadBatch() {
    this.disabledLog = true
    const timePicker = $('.timePicker2');
    let timeData = {
      startDate: timePicker.val().split('-')[0]
        ? timePicker.val().split('-')[0].trim()
        : '',
      endDate: timePicker.val().split('-')[1]
        ? timePicker.val().split('-')[1].trim()
        : '',
    }
    if (!timePicker.val()) {
      this.toastr.warning(this.translate.instant('CHUA_CHON_THOI_GIAN'), this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
    } else {
      this.batchService.getTokenDownloadBatchPP(timeData).subscribe((data) => {
        data._body.text().then((val) => {
          console.log('data', val)
          if (/^[\],:{}\s]*$/.test(val.replace(/\\["\\\/bfnrtu]/g, '@').replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {

            this.toastr.warning(`${JSON.parse(val).message}`, this.translate.instant('CANH_BAO'), {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
            //the json is ok
            console.log(1111)
          } else {
            console.log(22222)
            this.batchService.saveToFileSystem(data, 'application/vnd.ms-excel', 'Danh sách phân phối.xlsx')

            //the json is not ok

          }
        })
        this.disabledLog = false

      }, (error) => {
        this.disabledLog = false
      });
    }

  }

  /**Tuanba:21-11-2022: Bổ sung báo cáo**/
  exportReport() {
    $('.stampBoxStampAlertAdd').css('opacity', '0');
    this.messageExport = '';
    const timePicker = $('.timePicker');
    const created_time_val = $('.timePicker').val();
    const listDate = created_time_val.toString().split(' - ');
    console.log('listDate', listDate)
    if (created_time_val) {
      if (listDate.length > 1) {
        const a = listDate[0].split('/');
        const resultFrom = a[2] + '-' + a[1] + '-' + a[0];
        const b = listDate[1].split('/');
        const resultTo = b[2] + '-' + b[1] + '-' + b[0];
        const resultFromDate = moment(`${resultFrom}`)
        const resultToDate = moment(`${resultTo}`)
        const validateResult = resultToDate.diff(resultFromDate, 'days') + 1
        console.log('validateResult', validateResult)
        if (validateResult > 31) {
          this.validateDownloadExcelPopup.show();
          return;
        }
      }
    } else {
      this.validateDownloadExcelPopup.show();
      return;
    }
    let distributionAgent = '';
    if (
      $('#distributionAgent').val() === null ||
      isNaN($('#distributionAgent').val())
    ) {
      distributionAgent = '';
    } else {
      distributionAgent = $('#distributionAgent').val();
    }
    this.query = {
      serial: $('.serial').val(),
      // tslint:disable-next-line:max-line-length
      fromAgencyId: $('#classify').val() == 0 || $('#classify').val() == 3 || !$('#classify').val() ? $('#supplier').val() : distributionAgent,
      toAgencyId: $('#classify').val() == 0 || $('#classify').val() == 3 || !$('#classify').val() ? distributionAgent : $('#supplier').val(),
      fromProvinceId: $('#fromArea').val(),
      toProvinceId: $('#toArea').val(),
      // confirmationStatus: $('#confirmationStatus').val(),
      type: $('#classify').val(),
      warningType: $('#alertStatus').val(),
      routing: $('#logPP').val(),
      from: timePicker.val().split('-')[0]
        ? timePicker.val().split('-')[0].trim()
        : '',
      to: timePicker.val().split('-')[1]
        ? timePicker.val().split('-')[1].trim()
        : '',
    };

    // Tuanha: 28-11-2022: Remove empty field in query
    Object.keys(this.query).forEach((k) => !this.query[k] && delete this.query[k]);

    console.log('isSorting.typeSort ')
    const body = {
      exportTypeEnum: 'DISTRIBUTION_LOG',
      fields: this.query
    };
    this.exportService.exportReport(body).subscribe((res) => {
      if (res.code == 1) {
        this.messageExport = this.translate.instant('HE_THONG_DANG_XU_LY');
        $('.stampBoxStampAlertAdd').css('opacity', '1');
        setTimeout(() => {
          $('.stampBoxStampAlertAdd').css('opacity', '0');
        }, 5000);
      } else {
        this.toastr.error(res.message, this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        })
      }
    }, (error) => {
      this.toastr.error(error.message, this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      })
    });
  }

  closeModalValidateExport() {
    this.validateDownloadExcelPopup.hide();
  }

  hideDistribution(event) {
    this.isDistribution = event.isDistribution
    if (this.data.length > 0) {
      this.viewDetail(this.data[0], 0)
    }
    this.toastr.warning(this.translate.instant('DA_DONG_GIAO_DIEN_PHAN_PHOI'), this.translate.instant('THONG_BAO'), {
      timeOut: 4000,
      positionClass: 'toast-top-right'
    })
  }

  /** Tuanba:19-09-2023: Thêm button kích hoạt bảo hành tai mỗi log phân phối **/
  modalRef: any;
  infoActive: any = {};
  cusomerUpdate: any = {};
  listRequire: any = [];

  imagesFields: any = {};

  listField;

  // tslint:disable-next-line:member-ordering
  list_districtActive: Array<IOption> = [];
  list_city: Array<IOption> = [];
  typeField = {};
  typeName = {};
  public errMsgAlertSingleStamp = '';
  public transfer_id: any;
  public canUpdateAgency: any;

  openActiveTemp(template: TemplateRef<any>) {
    console.log('thí.sadasd', this.transfer_id)
    this.productRoadmapService.getListSerialActiveGuarannte(this.transfer_id).subscribe((res) => {
      console.log('res', res)
      if (res.code == 1) {
        const result = res.data.map(item => `${item.prefix}-${item.number}`).join('\n');
        $('#serial_ids').val(`${result}`)
        console.log('result', result)
      }

    })
    this.modalRef = this.modalService.show(template);
    this.choiceActive();
  }

  getListDistrict(city_Id: any, districtID: any, status) {
    if (city_Id) {
      this.addressService
        .getDistrict({ city_id: city_Id })
        .toPromise()
        .then((res: any) => {
          if (res.status == 200) {
            const districts = [];
            for (const d of res.data.districts) {
              districts.push({ value: d.id.toString(), label: d.name });
            }
            this.list_districtActive = districts;
            console.log('list_districtActive', this.list_districtActive)
            console.log('districtID', districtID)

            this.infoActive.district = districtID ? districtID.toString() : null;

          }
        });
    }
  }

  deleteImageFields(id, fieldKey) {
    for (let i = 0; i < this.imagesFields[fieldKey].length; i++) {
      if (this.imagesFields[fieldKey][i].id === id) {
        this.imagesFields[fieldKey].splice(this.imagesFields[fieldKey].indexOf(this.imagesFields[fieldKey][i]), 1);
        break;
      }
    }
  }

  tusUploadFields = (item, fieldKey) => {
    const numberImages = item.target.files.length;
    if (numberImages > 5) {
      this.toastr.error(this.translate.instant('MAX_5_IMAGES'), '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else {
      for (const image of item.target.files) {

        const fileData = new FormData();
        // @ts-ignore
        fileData.append('file', image);
        return this.upload.uploadImagesNew2(fileData).subscribe((response: any) => {
          const res = JSON.parse(response._body)
          if (res.status === 200) {
            const image2 = res.data.url;
            if (this.imagesFields[fieldKey].length >= 5) {
              this.toastr.error(this.translate.instant('MAX_5_IMAGES'), '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.imagesFields[fieldKey].push(image2);
            }
          }
        });
      }
    }
  };

  choiceActive() {
    // this.status = 1;
    console.log('ngan beo');
    this.cusomerUpdate = {}
    this.listRequire = []
    this.cusomerUpdate['nameField'] = {}
    this.cusomerUpdate['fields'] = {}
    this.stampService.getFieldGuaranteeCustomes().subscribe((res) => {
      if (res.data.length > 0) {
        this.listField = res.data;
        console.log('this.listField', this.listField)
        this.listField.map((val) => {
          this.typeField[val.key] = val.type
          this.typeName[val.key] = val.name
          if (val.require === 1 && val.status === 1) {
            this.listRequire.push(val.key)
          }
          this.cusomerUpdate['nameField'][val.key] = val.name


          if (val.type === 'checkbox') {
            this.cusomerUpdate['fields'][val.key] = {}
            val.value_f.map((n) => {
              this.cusomerUpdate['fields'][val.key][`check${n.id}`] = false
            })
          }
          if (val.type === 'image') {
            this.imagesFields[val.key] = []
            this.cusomerUpdate['fields'][val.key] = []
            console.log('this.imagesFields', this.imagesFields)
          }


          if (this.infoActive.fields && this.infoActive.fields.length > 0 && this.infoActive.fields !== null) {
            this.infoActive.fields.map((item) => {
              if (item.key === val.key) {
                if (val.type === 'date') {
                  this.cusomerUpdate['fields'][val.key] = moment(item.value).format('DD/MM/YYYY')
                } else if (val.type === 'checkbox') {
                  this.cusomerUpdate['fields'][val.key] = {}
                  val.value_f.map((n) => {
                    if (item.string_values.split(',').includes(String(n.id))) {
                      this.cusomerUpdate['fields'][val.key][`check${n.id}`] = String(n.id)
                    }
                  })
                } else if (val.type === 'image') {
                  this.imagesFields[val.key] = item.string_values === null ? [] : item.string_values
                } else {
                  this.cusomerUpdate['fields'][val.key] = item.string_values
                }
              }

            })

          }
          console.log('this.cusomerUpdate', this.cusomerUpdate)
        })
      }

    });

  }

  findCustomerByPhone() {
    console.log(111);
    if (this.infoActive.phone) {
      if (this.infoActive.phone.length > 0) {
        this.stampService
          .getUserByPhone(this.infoActive.phone)
          .subscribe((res) => {
            if (!res.error) {
              if (res.data.customer) {
                // tslint:disable-next-line:prefer-const
                let info = res.data.customer;
                this.toastr.info(
                  `Đã tải về thông tin khách hàng có số điện thoại` +
                  this.infoActive.phone,
                  '',
                  {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right',
                  });
                this.infoActive.name = info.name;
                this.infoActive.email = info.email;
                this.infoActive.address = info.address;
                this.infoActive.fields = info.fields;


                this.cusomerUpdate = {}
                this.listRequire = []
                this.cusomerUpdate['nameField'] = {}
                this.cusomerUpdate['fields'] = {}
                this.stampService.getFieldGuaranteeCustomes().subscribe((res) => {
                  if (res.data.length > 0) {
                    this.listField = res.data;
                    this.listField.map((val) => {
                      this.typeField[val.key] = val.type
                      this.typeName[val.key] = val.name
                      if (val.require === 1 && val.status === 1) {
                        this.listRequire.push(val.key)
                      }
                      this.cusomerUpdate['nameField'][val.key] = val.name
                      if (val.type === 'checkbox') {
                        this.cusomerUpdate['fields'][val.key] = {}
                        val.value_f.map((n) => {
                          this.cusomerUpdate['fields'][val.key][`check${n.id}`] = false
                        })
                      }
                      if (this.infoActive.fields && this.infoActive.fields.length > 0) {
                        this.infoActive.fields.map((item) => {
                          if (item.key === val.key) {

                            if (val.type === 'date') {

                              this.cusomerUpdate['fields'][val.key] = moment(item.value).format('DD/MM/YYYY')
                            } else if (val.type === 'checkbox') {
                              this.cusomerUpdate['fields'][val.key] = {}
                              val.value_f.map((n) => {
                                if (item.string_values.split(',').includes(String(n.id))) {
                                  this.cusomerUpdate['fields'][val.key][`check${n.id}`] = String(n.id)
                                }
                              })

                            } else if (val.type === 'image') {
                              this.imagesFields[val.key] = item.string_values === null ? [] : item.string_values
                            } else {
                              this.cusomerUpdate['fields'][val.key] = item.string_values

                            }
                          }

                        })
                      }
                    })
                  }

                });


                if (info.city && info.district) {
                  this.infoActive.city = info.city.toString();
                  this.getListDistrict(
                    this.infoActive.city,
                    info.district,
                    1
                  );
                }

              }
            }
          });
      }
    }
  }

  excecute() {

    this.errMsgAlertSingleStamp = '';
    const request: any = {
      customer: {},
    };
    request.status = 1;
    request.bundleType = 0;
    if (!this.infoActive.phone || this.infoActive.phone == '') {
      this.toastr.warning(`Số điện thoại không được để trống`, '', {
        timeOut: 400000000,
        positionClass: 'toast-bottom-right',
      });
      return;
    } else {
      request.customer.phone = this.infoActive.phone;
      $('#phoneValidate').text('');
    }

    if (!this.infoActive.name || this.infoActive.name == '') {
      this.toastr.warning(`Tên khách hàng không được để trống`, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return;
    } else {
      request.customer.name = this.infoActive.name;
      $('#nameValidate').text('');
    }
    this.infoActive.serial_ids = $('#serial_ids').val()
    console.log('$(\'#serial_ids\').val()', $('#serial_ids').val())
    if (!this.infoActive.serial_ids || this.infoActive.serial_ids == '') {
      this.toastr.warning(`Serial không được để trống`, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return;
    } else {
      const listContent = [];
      const content = this.infoActive.serial_ids.toUpperCase().split('\n');
      content.map((res) => {
        if (res.trim().length > 0) {
          if (!isNaN(res.trim().split('-')[res.trim().split('-').length - 1])) {
            listContent.push({
              prefix: res.trim().split('-')[0],
              serialStart: res.trim().split('-')[res.trim().split('-').length - 1],
              serialEnd: res.trim().split('-')[res.trim().split('-').length - 1]
            });
          } else {
            this.toastr.warning(
              `Định dạng serial không đúng`,
              `Kích hoạt thất bại`,
              {
                timeOut: 3000,
                positionClass: 'toast-bottom-right',
                enableHtml: true,
              }
            );
            return
          }

        }
      });
      request.stamps = listContent;
      $('#serialValidateInfoActive').text('');
    }
    if (this.infoActive.email && this.infoActive.email != '') {
      request.customer.email = this.infoActive.email;
    } else {
      request.customer.email = ''
    }
    if (this.infoActive.address && this.infoActive.address != '') {
      request.customer.address = this.infoActive.address;
    } else {
      request.customer.address = ''
    }
    // if (this.infoActive.country && this.infoActive.country != '') {
    //   request.customer.country = parseInt(this.infoActive.country);
    // }
    if (this.infoActive.city && this.infoActive.city != '') {
      request.customer.city = parseInt(this.infoActive.city);
    }
    if (this.infoActive.district && this.infoActive.district != '') {
      request.customer.district = parseInt(this.infoActive.district);
    }

    // if (this.variantId) {
    //   request.variant_id = this.variantId;
    // }

    if (this.infoActive.product_code) {
      request.product_code = this.infoActive.product_code;
    }
    console.log('request', request);

    for (const val in this.imagesFields) {
      console.log(`${val}: ${this.imagesFields[val]}`);
      this.cusomerUpdate['fields'][val] = this.imagesFields[val];
    }

    const fieldsData = {}
    for (const property in this.cusomerUpdate['fields']) {
      if (this.typeField[property] === 'select' && this.listRequire.includes(property) && this.cusomerUpdate['fields'][property] === '-1') {
        this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
        return;
      }
      if (this.typeField[property] === 'image') {
        fieldsData[property] = this.cusomerUpdate['fields'][property]
        if (this.listRequire.includes(property) && fieldsData[property].length === 0) {
          this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          return;
        }
      }

      if (this.typeField[property] === 'checkbox') {
        const arr = []
        for (const val in this.cusomerUpdate['fields'][property]) {
          if (typeof this.cusomerUpdate['fields'][property][val] === 'boolean') {
            if (this.cusomerUpdate['fields'][property][val]) {
              const split = val.split('check')[1]
              arr.push(split)
            }
          } else {
            arr.push(this.cusomerUpdate['fields'][property][val])
          }

        }
        fieldsData[property] = arr.join(',')

        if (this.listRequire.includes(property) && !fieldsData[property]) {
          this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          return;

        }
      } else if (this.typeField[property] === 'date') {
        console.log('this.cusomerUpdate.fields[property]', this.cusomerUpdate['fields'][property])
        if (this.cusomerUpdate['fields'][property]) {
          let dataDate = this.cusomerUpdate['fields'][property]
          if (typeof this.cusomerUpdate['fields'][property] === 'object') {
            dataDate = moment(this.cusomerUpdate['fields'][property]).format('DD/MM/YYYY')
          }
          const date = dataDate.split('/')
          const dateTime = new Date(`${date[1]} ${date[0]} ${date[2]}`)
          fieldsData[property] = new Date(dateTime.getTime() - (dateTime.getTimezoneOffset() * 60000)).toISOString();
        }
        if (this.listRequire.includes(property) && !fieldsData[property]) {
          this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          return;

        }
      } else {

        fieldsData[property] = this.cusomerUpdate['fields'][property]

        if (this.listRequire.includes(property) && !fieldsData[property]) {
          this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          return;
        }
      }

    }
    request.customer.fields = fieldsData
    if (
      request.customer.phone &&
      request.customer.phone !== '' &&
      request.customer.name &&
      request.customer.name !== ''
    ) {
      this.stampService
        .activeGuaranteeStamps(request)
        .toPromise()
        .then((res: any) => {
          if (res.code === 1) {

            this.toastr.success(
              `<div>Thành công: <b>${res.data.totalSuccess}</b>, Thất bại: <b>${res.data.totalFailure}</b></div>`,
              `Kích hoạt thành công`,
              {
                timeOut: 5000,
                positionClass: 'toast-bottom-right',
                enableHtml: true,
              }
            );
            // this.loadData({}, this.isSorting);
            this.modalRef.hide();
            this.infoActive = {};
          } else if (res.code === 1800) {

            this.errMsgAlertSingleStamp = res.message;
            $('.stampSingleAlert').css('opacity', '1');
            // this.loadData({}, this.isSorting);
            this.modalRef.hide();
            this.infoActive = {};
            setTimeout(() => {
              $('.stampSingleAlert').css('opacity', '0');
            }, 5000)
          } else {
            this.toastr.error(
              res.message || `Kích hoạt thất bại`,
              `Thất bại`,
              {
                timeOut: 5000,
                positionClass: 'toast-bottom-right',
                enableHtml: true,
              }
            );
            EvsErr.evs_err(res, false);
          }
        })
        .catch((err: any) => {
          this.errMsgAlertSingleStamp = err.message;
          $('.stampSingleAlert').css('opacity', '1');
          setTimeout(() => {
            $('.stampSingleAlert').css('opacity', '0');
          }, 5000)
          // this.toastr.error(err.message, '', {
          //   timeOut: 5000,
          //   positionClass: 'toast-bottom-right',
          // });
        });
    }
  }

  keyPressEvent(event: KeyboardEvent) {
    console.log('event', event)
    const specialChars = /[~`!@#$%^&*()_\-=\[\]{};':"\\|,.<>\/?]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (specialChars.test(inputChar)) {
      console.log('abc+')
      event.preventDefault();
      // return /(84|0[3|5|7|8|9])+([0-9]{8})\b/.test(number);
      return
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/productRoadmap/productRoadmap.component.ts